var map = {
	"./betting_icon.embedded.svg": 1297,
	"./champions_league.embedded.svg": 1298,
	"./conmebol_icon.embedded.svg": 1299,
	"./csgo_icon.embedded.svg": 1300,
	"./dfs_icon.embedded.svg": 1301,
	"./dota2_icon.embedded.svg": 1302,
	"./dr_pepper.embedded.svg": 1303,
	"./dreamhack_icon.embedded.svg": 1304,
	"./esl_icon.embedded.svg": 1305,
	"./fifa.embedded.svg": 1306,
	"./fnatic_icon.embedded.svg": 1307,
	"./fortnite.embedded.svg": 1308,
	"./i_league_icon.embedded.svg": 1309,
	"./logo-12up.embedded.svg": 542,
	"./logo-90min.embedded.svg": 543,
	"./logo-dbltap.embedded.svg": 544,
	"./logo-ei.embedded.svg": 545,
	"./logo-floor8.embedded.svg": 546,
	"./logo-ftb90.embedded.svg": 547,
	"./logo-german_site.embedded.svg": 548,
	"./logo-ht_media.embedded.svg": 549,
	"./logo-pluralist.embedded.svg": 550,
	"./logo-theduel-mobile.embedded.svg": 551,
	"./logo-theduel.embedded.svg": 552,
	"./lol_icon.embedded.svg": 1310,
	"./mdl_icon.embedded.svg": 1311,
	"./melee_icon.embedded.svg": 1312,
	"./mlb_icon.embedded.svg": 1313,
	"./mls_icon.embedded.svg": 1314,
	"./nba_icon.embedded.svg": 1315,
	"./ncaa-basketball_icon.embedded.svg": 1316,
	"./ncaa-football_icon.embedded.svg": 1317,
	"./nfl_icon.embedded.svg": 1318,
	"./overwatch_icon.embedded.svg": 1319,
	"./powered-by-ei.embedded.svg": 553,
	"./powered-by-german_site.embedded.svg": 554,
	"./powered-by-ht_media.embedded.svg": 555,
	"./pubg.embedded.svg": 1320,
	"./smash4_icon.embedded.svg": 1321,
	"./streetfighter_icon.embedded.svg": 1322,
	"./suzuki_cup.embedded.svg": 1323,
	"./theduel-nav.embedded.svg": 1324,
	"./theduel_menu_icon.embedded.svg": 1325,
	"./women-football.embedded.svg": 1326,
	"./world-cup.embedded.svg": 1327,
	"./yousport_icon.embedded.svg": 1328
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1340;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*\.embedded\.svg$
// module id = 1340
// module chunks = 33